import axios from 'axios'
import i18n from '@/i18n'

export default {
  baseURL: process.env.BASE_URL + "api/dashboard",

  getDashboardParameters(filter) {
    return [
      filter.regions,
      filter.subregions,
      filter.nscs,
      filter.nscsub,
      filter.areas,
      filter.dealergroups
    ].filter(Boolean).join('|');
  },

  getKpiQuestions(filter, cancelToken, localizationId) {
    let customProps = this.getDashboardParameters(filter);

    return axios
      .get("dashboard-kpi-questions-bmw", {
        baseURL: this.baseURL,
        params: {
          "brand-ids": filter.brand,
          "survey-ids": filter.surveys,
          "wave-ids": filter.waves,
          "custompropertyvalue-ids": customProps.split('§').join('|'),
          "clientlocation-ids": filter.outlets || null,
          "kpi-codes": filter.kpiCodes,
          "localization-id": localizationId || i18n.global.locale
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        log.error(error);
      });
  },

  getDashboardEndpoint(filter, parameters) {
    let apiEndpoint = "bmw2018";
    if (filter && filter.api) {
      switch (filter.api) {
        case '2021':
          apiEndpoint = "bmw2021";
          break;
        case '2021compare':
          apiEndpoint = "bmw2021compare";
          break;
        case 'bmw2021experimental':
          apiEndpoint = "bmw2021experimental";
          parameters['relevant-kpis'] = filter?.RelevantKpis?.join(',');
      }
    }
    return apiEndpoint;
  },

  getDashboard(filter, cancelToken, localizationId) {
    let customProps = this.getDashboardParameters(filter);

    let parameters = {
      "brand-ids": filter.brand,
      "survey-ids": Array.isArray(filter.surveys) ? filter.surveys.join(',') : filter.surveys,
      "wave-ids": filter.waves,
      "custompropertyvalue-ids": customProps.split('§').join('|'),
      "clientlocation-ids": filter.outlets || null,
      "websiteanswers": filter.contactinitiation || null,
      "localization-id": localizationId || i18n.global.locale,
      "page": filter.page || null
    };

    let apiEndpoint = this.getDashboardEndpoint(filter, parameters);
    log.warn("API BMW getDashboard: ", apiEndpoint, parameters);
    return axios
      .get(apiEndpoint, {
        baseURL: this.baseURL,
        params: parameters,
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .catch(function(error) {
        log.error(error);
      });
  },

  getApplicationManual(localizationId, documentVariant, cancelToken) {
    return axios
      .get("manual", {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.global.locale,
          "documentvariant": documentVariant
        },
        responseType: "blob",
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        log.error(error);
      });
  },

  getStaticDocument(localizationId, documentVariant, documentType, cancelToken) {
    return axios
      .get("staticdocument", {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.global.locale,
          "documentvariant": documentVariant,
          "documenttype": documentType
        },
        responseType: "blob",
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        log.error(error);
      });
  },

  appendPropertyValue(props, text) {
    if (_.isEmpty(text)) {
      return props;
    }
    if (props.length > 0) {
      return props + "|" + text;
    }
    return text;
  },

  getOptionsCustomProps(filter) {
    if (!filter) {
      return '';
    }

    try {
      let customProps = '';
      customProps = this.appendPropertyValue(customProps, filter.Regions?.join('|') || filter.regions);
      customProps = this.appendPropertyValue(customProps, filter.Subregions?.join('|') || filter.subregions);
      customProps = this.appendPropertyValue(customProps, filter.NSCs?.join('|') || filter.nscs);
      customProps = this.appendPropertyValue(customProps, filter.SubNSCs?.join('|') || filter.nscsub);
      customProps = this.appendPropertyValue(customProps, filter.Areas?.join('|') || filter.areas);
      customProps = this.appendPropertyValue(customProps, filter.Dealergroups?.join('|') || filter.dealergroups);
      return customProps;
    } catch (error) {
      log.error(error);
      return '';
    }
  },

  getFiltersEndpoint(filter) {
    let apiEndpoint = "filters";
    if (filter && filter.api) {
      switch (filter.api) {
        case '2021':
          apiEndpoint = "filters2021";
          break;
        case '2021compare':
          apiEndpoint = "filters2021compare";
          break;
      }
    }
    return apiEndpoint;
  },

  getOptions(filter, cancelToken, localizationId) {
    let customProps = this.getOptionsCustomProps(filter);
    let brands = _.isEmpty(filter) ? '' : (filter.Brand?.join('|') || filter.brand);
    const parameters = {
      "brand-ids": brands,
      "custompropertyvalue-ids": customProps.split('§').join('|'),
      "localization-id": localizationId || i18n.global.locale
    };

    let apiEndpoint = this.getFiltersEndpoint(filter);
    log.error("API BMW getOptions: ", apiEndpoint, parameters);
    return axios
      .get(apiEndpoint, {
        baseURL: this.baseURL,
        params: parameters,
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        log.error(error);
      });
  },

  postOptions(filterBody, cancelToken) {
    return axios.post("filters",
      filterBody,
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        log.error(error);
      });
  },

  /**************************/
  /* CX - CustomerXperience */
  /**************************/
  getCXMarket(filter, options, cancelToken) {
    return axios.post(
      "/cxmarket-bmw",
      {
        ClientId:       filter?.ClientId || null,
        LocalizationId: filter?.LocalizationId || i18n.global.locale,
        // KpiCode:        filter?.KpiCode || null,
        // IsKpiGroup:     filter?.IsKpiGroup || 0,
        Year:           filter?.Year || null,
        Brand:          filter?.Brand || null
        // 1105^BMW|1105^GKL|1105^xEV (BMW i)|1105^xEV (PHEV)::: BMW
        // 1105^MINI|1105^xEV (MINI Electric)|1105^xEV (PHEV MINI)... Mini
        // -1^BMW Motorrad... BMW Moto ...
      },
      {
        baseURL:        this.baseURL,
        cancelToken:    cancelToken?.token || null
      }
    );
  },

  getCXDealers(filter, options, cancelToken) {
    return axios.post(
      "/cxdealers",
      {
        CountryId:      filter.CountryId || null,
        ClientId:       filter.ClientId || null,
        LocalizationId: filter.LocalizationId || i18n.global.locale,

        // Optional
        SearchText:     options?.searchText || null,
        PageSize:       options?.pageSize || 999,
        Page:           options?.page || null
      },
      {
        baseURL:        this.baseURL,
        cancelToken:    cancelToken?.token || null
      }
    )
  },

  getCXKpi(filter, options, cancelToken) {
    return axios
      .get("cxkpi", {
        baseURL: this.baseURL,
        params:  filter,
        cancelToken: cancelToken?.token || null
      });
  },

  getDealer(filter, cancelToken) {
    if (filter == null || filter.LocationIds == null || filter.LocationIds == "")
      return Promise.reject();

    return axios.post(
      "/dealer-bmw",
      {
        ClientLocationId: filter.LocationIds || null,
        LocalizationId:   i18n.global.locale,
        ScoreId:          filter?.scoreId || -1,      // default für Overall Score
        Year:             filter?.year || 2022        // default ist aktuelles Jahr
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken?.token || null
      }
    );
  },

  getClientLocationCountries(clientId, cancelToken) {
    return axios
      .get("client-location-countries", {
        baseURL: this.baseURL,
        params: {
          "client-id": clientId,
          // REP.CountryText has only de-DE and deflt ?
          "localization-id": i18n?.locale?.startsWith("de")
            ? i18n?.locale
            : "deflt"
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      });
  },

  getClientCountries(clientId, localizationId, cancelToken) {
    return axios
      .get("client-location-countries", {
        baseURL: this.baseURL,
        params: {
          "client-id": clientId,
          "localization-id": localizationId || i18n?.locale
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      });
  }
};
